// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';
import offCanvas                from './offCanvas';
// import Simplelightbox from './SimpleLightBox';
const { default: axios } = require("axios");
require("fslightbox");

// import styles bundle
import 'swiper/css/bundle';

const SwiperGalleries = function () {

    //galeria webdoor
    const gallerySwiperWebdoor = () => {
        // init Swiper:
        const swiper = new Swiper('.swiperFull', {
            speed       : 2000,
            loop        : true,
            effect      : 'slide',
            autoplay    : {
                delay: 5000,
                disableOnInteraction: false,
              },
            pagination  : {
                el: ".swiper-pagination",
                clickable: true,
                renderBullet: function (index, className) {
                  return '<span class="' + className + '">' + (index + 1) + "</span>";
                },
              },
        });
    }

    //galeria apartamentos
    const galleryViewDinamic = () => {

        const galVDinamic = ".swipper-view-dinamic";
        if($(galVDinamic).length <= 0) return;

        $(galVDinamic).each(function(i,e){

            let perView = $(e).attr('data-view');
            let totSliders = $(e).find('.swiper-slide').length;

            if(totSliders < $(e).attr('data-view')) {
                perView = totSliders;
            };

            const swiperHoriz = new Swiper(e, {
                // cssMode     : true,
                speed:1000,
                slidesPerView: 1,
                loop: true,
                autoplay    : {
                    delay: 10000,
                },
                spaceBetween: 20,
                createElements: true,
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
                navigation: {
                    nextEl: '.swiper-button-next-dinamic',
                    prevEl: '.swiper-button-prev-dinamic',
                },
                breakpoints: {
                    992: {
                        slidesPerView: 3,//parseInt(perView),
                        spaceBetween: 30,
                    },
                }
            });

        });

    }


    // galeria de imagens widescreen
    const galleryWide = () => {

        if($('.swiper-wide').length <= 0) return;

        const swiper = new Swiper('.swiper-wide', {
            speed       : 2000,
            loop        : true,
            effect      : 'slide',
            createElements: true,
            autoplay    : {
                delay: 5000,
              },
              pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
        });
    }


    // descubraSP - galerias alteradas por ajax
    const changeGalleryCat = (el) => {
        
        let _parent           = el.closest('.parentAjaxGalCategory');
        let galCatSelected    = el.attr('data-type'); 
        let urlGal            = el.attr('data-url'); 

        if( isMob() ){
            galCatSelected  = _parent.find('.changeGalCategory option:selected').attr('data-type');
            urlGal          = _parent.find('.changeGalCategory option:selected').attr('data-url');
        }

        // console.log(el);
        // console.log(galCatSelected);
        // console.log(urlGal);
        
        $('.changeGalCategory').removeClass('active');
        el.addClass('active');

        Swal.fire({
            title: '',
            allowOutsideClick: false,
            showCancelButton: false,
            showCloseButton: false,
            background:'transparent',
            didOpen: () => {
                Swal.showLoading()
            }
        });

        axios.get(urlGal, {
            params : {
                slug : galCatSelected
            }
        })
            .then(function (response) {
                const data = response;                
                _parent.find('.ajaxGalCategory').html(data.data);   
                galleryViewDinamic();
                Swal.close();
                offCanvas.init();

            }).catch( error => {
                Swal.fire({
                    icon: 'error',
                    title: error,
                    showConfirmButton: true,
                    // timer: 3000
                })
            });
    }

    // ledForum - imagens alteradas por ajax
    const changeImagesCat = (el) => {
    
        const _parent               = el.closest('.parentAjaxGalCategory');
        // const galCatSelected     = el.attr('data-type'); 
        const urlGal                = el.attr('data-url'); 
        const titleImgAjax          = _parent.find('.js-dinamic-title');
        const textImgAjax           = _parent.find('.js-dinamic-text');
        const linkImgAjax           = _parent.find('.js-dinamic-link');
        const linkPaginationAjax    = _parent.find('.js-dinamic-pagination');
        
        $('.changeImageCategory').removeClass('active');
        el.addClass('active');

        $('.act-link.ajax-more').fadeIn(300);

        Swal.fire({
            title: '',
            allowOutsideClick: false,
            showCancelButton: false,
            showCloseButton: false,
            background:'transparent',
            didOpen: () => {
                Swal.showLoading()
            }
        });

        axios.get(urlGal)
            .then(function (response) {
                const data = response.data;       
                
                titleImgAjax.text(data.title);   
                textImgAjax.html(data.content);   
                linkPaginationAjax.attr('data-url', urlGal);   
                linkPaginationAjax.attr('data-page', 1); 
                linkPaginationAjax.attr('data-totalpage', data.total_pages); 
                
                if(data.link != '') {
                    linkImgAjax.attr('href', data.link);
                    linkImgAjax.removeClass('d-none');   
                    linkImgAjax.show();                    
                } else {
                    linkImgAjax.hide();                    
                }

                _parent.find('.ajaxImageCategory').html(data.files);

                if(linkPaginationAjax.attr('data-page') >= (data.total_pages)){
                    $('.act-link.ajax-more').fadeOut(300);
                }

                // Simplelightbox.constlightBx();
                refreshFsLightbox();
                
                Swal.close();

            }).catch( error => {
                Swal.fire({
                    icon: 'error',
                    title: error,
                    showConfirmButton: true,
                    // timer: 3000
                })
            });
    }

    const isMob = () => $(window).width() < 992;


    return {

        // gallerySwiperWebdoor    : gallerySwiperWebdoor,

        init : () => {
            galleryViewDinamic();
            galleryWide();

            if( !isMob() ){
                $('.changeGalCategory').on('click', function(){
                    changeGalleryCat($(this));
                })
                
                $('.changeImageCategory').on('click', function(){
                    changeImagesCat($(this));
                })
            } else {
                console.log('else');
                $('.changeGalCategory').on('change', function(){
                    changeGalleryCat($(this));
                })
                
                $('.changeImageCategory').on('change', function(){
                    changeImagesCat($(this));
                });
            }

        }



    }

}();

export default SwiperGalleries;
